import { object, ref, string } from "yup";

export const getValidation = () => {
  const validationSchema = object().shape({
    firstName: string()
      .default("")
      .required(),
    lastName: string()
      .default("")
      .required(),
    email: string()
      .default("")
      .required()
      .email()
      .trim(),
    password: string()
      .required()
      .default(""),
    confirmPassword: string()
      .required()
      .default("")
      .oneOf(
        [ref("password"), null],
        "Password doesn't match Confirm Password."
      ),
    pin: string()
      .required("PIN can't be blank.")
      .default(""),
    userRole: string()
      .nullable()
      .required("Role can't be blank.")
      .default("")
  });

  return {
    validationSchema,
    defaultValues: validationSchema.cast({})
  };
};
